var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRipeningIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "76.000000pt",
    viewBox: "0 0 64.000000 76.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,76.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 666 c0 -95 33 -146 96 -146 l36 0 -26 48 -26 47 28 -33 c16 -17 32 -29 35 -25 9 9 9 65 -1 79 -7 12 -125 84 -136 84 -3 0 -6 -24 -6 -54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 603 c-14 -13 8 -33 36 -33 75 0 178 -83 209 -168 66 -182 -62 -367 -252 -366 -107 1 -205 66 -245 161 -20 46 -19 53 5 53 11 0 20 2 20 4 0 9 -53 96 -58 96 -7 0 -52 -80 -52 -91 0 -4 8 -9 18 -11 10 -3 24 -26 34 -54 22 -62 86 -129 158 -163 140 -66 319 -4 391 135 32 64 35 207 4 269 -27 54 -93 119 -146 142 -46 21 -114 35 -122 26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 573 c-42 -8 -56 -73 -20 -87 23 -8 44 4 60 35 28 53 19 64 -40 52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 401 l0 -101 -46 -45 c-34 -32 -45 -49 -40 -61 6 -15 15 -9 59 34 l52 52 0 107 c0 76 -4 107 -12 110 -10 4 -13 -20 -13 -96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462 448 c-16 -16 -15 -38 1 -38 17 0 37 20 37 37 0 16 -22 17 -38 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 425 c-13 -7 -38 -11 -55 -8 -18 3 -38 -2 -50 -11 -18 -14 -8 -15 115 -14 74 0 124 3 110 5 -14 3 -30 9 -35 13 -26 22 -61 28 -85 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 305 c0 -10 10 -15 30 -15 20 0 30 5 30 15 0 10 -10 15 -30 15 -20 0 -30 -5 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 187 c0 -8 9 -22 19 -31 24 -22 37 -5 19 24 -14 23 -38 27 -38 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328 145 c-10 -11 5 -55 19 -55 10 0 13 9 11 27 -3 25 -18 40 -30 28z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipeningIcon);
export default __webpack_public_path__ + "static/media/ripening-icon.ccde961965d1adea9cff711c4f797c5f.svg";
export { ForwardRef as ReactComponent };